import { PaymentErrors } from 'constants/payment';
import type { TranslationKey } from 'locales/flattenMessages';

const normalizeString = (str: string) => str.toLowerCase().replace(/\s+/g, ' ').trim();

const normalizedPaymentErrors = Object.entries(PaymentErrors).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [normalizeString(key)]: value,
  }),
  {} as Record<string, TranslationKey>,
);

export const getTranslationKey = (errorCode: string): TranslationKey | null => {
  const cleanCode = normalizeString(errorCode);

  return normalizedPaymentErrors[cleanCode] || null;
};

export const getPaymentErrorKey = (
  errorCode?: keyof typeof PaymentErrors,
  altMessage?: TranslationKey,
): TranslationKey => {
  if (!errorCode) return altMessage || 'error';

  const translationKey = getTranslationKey(errorCode);

  if (translationKey) {
    return translationKey;
  }

  return altMessage || 'error';
};
